import React, { Component } from 'react';
import { Link } from 'react-router';

import moment from "moment";
import { Bar } from "react-chartjs";

import OrganizationSelect from "../../components/OrganizationSelect";
import Pagination from "../../components/Pagination";
import GatewayStore from "../../stores/GatewayStore";
import SessionStore from "../../stores/SessionStore";


class SearchBox extends Component {
  constructor() {
    super();

    this.state = {
      ignoreActive: false,
      searchText:"",
    };
  }

  onCheckChange(e){
    let v = e.target.checked

    this.setState({
      ignoreActive: v,
    });

    if(this.props.onSearch){
      this.props.onSearch(this.state.searchText,v);
    }
  }

  onTextChange(e){
    let v = e.target.value

    this.setState({
      searchText: e.target.value,
    });

    if(this.props.onSearch){
      this.props.onSearch(v,this.state.ignoreActive);
    }
  }

  render(){
    return (
      <div>
        <label>
          <input type="text" placeholder="input key to search"  value={this.state.searchText || ''} onChange={this.onTextChange.bind(this)} /> &nbsp;&nbsp;&nbsp;&nbsp;
        </label>
         <label>
          <input type="checkbox" name="ckIgnoreInactive" checked={this.state.ignoreActive} onChange={this.onCheckChange.bind(this)} /> Ignore inactive 
        </label>
      </div>
    );
  }
}


class GatewayRow extends Component {
  constructor() {
    super();

    this.state = {
      stats: {
        labels: [],
          datasets: [
            {
              data: [],
              fillColor: "rgba(33, 150, 243, 1)",
            },
          ],
      },
      options: {
        animation: false,
        showScale: false,
        showTooltips: false,
        barShowStroke: false,
        barValueSpacing: 5,
      },
    };
  }


  componentWillMount() {
    GatewayStore.getGatewayStats(this.props.gateway.mac, "DAY", moment().subtract(29, 'days').toISOString(), moment().toISOString(), (records) => {
      let stats = this.state.stats;
      for (const record of records) {
        stats.labels.push(record.timestamp);
        stats.datasets[0].data.push(record.rxPacketsReceived + record.txPacketsReceived);
      }

      this.setState({
        stats: stats,
      });
    });
  }

  render() {
    let uptime = "";

    uptime = this.props.gateway.uptime;

    // if (typeof(this.props.gateway.uptime) !== "undefined" && this.props.gateway.uptime !== "") {
    //   let t = moment(this.props.gateway.uptime);
    //   if(t.year() <= 2010){
    //     uptime = "N/A"
    //   }else{
    //     uptime = t.fromNow(); 
    //   }   
    // }

    return(
      <tr>
        <td><Link to={`organizations/${this.props.gateway.organizationID}/gateways/${this.props.gateway.mac}`}>{this.props.gateway.name}</Link></td>
        <td>{this.props.gateway.mac}</td>
        <td>{this.props.gateway.description}</td>
        <td>{uptime}</td>
        <td>
          <Bar width="380" height="23" data={this.state.stats} options={this.state.options} />
        </td>
      </tr>
    );
  }
}

class ListGateways extends Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired
  };

  constructor() {
    super();

    this.state = {
      gateways: [],
      pageSize: 10,
      pageNumber: 1,
      pages: 1,
      isAdmin: false,
      currentSort: 'asc',
      currentSortkey:'name',
      ignoreActive: false,
      searchText:"",
    };

    this.updatePage = this.updatePage.bind(this);
  }

  componentDidMount() {
    this.updatePage(this.props);


    SessionStore.on("change", () => {
      this.setState({
        isAdmin: SessionStore.isAdmin() || SessionStore.isOrganizationAdmin(this.props.params.organizationID), 
      });
    });
  }

  componentWillReceiveProps(nextProps) {
    this.updatePage(nextProps);
  }

  updatePage(props) {
    this.setState({
      isAdmin: SessionStore.isAdmin() || SessionStore.isOrganizationAdmin(props.params.organizationID),
    });

    const page = (props.location.query.page === undefined) ? 1 : props.location.query.page;

    let desc = 0
    if (this.state.currentSort === "desc") {
      desc = 1
    }

    GatewayStore.getAllForOrganization(this.props.params.organizationID, this.state.pageSize, (page-1) * this.state.pageSize, this.state.currentSortkey, desc, this.state.ignoreActive,this.state.searchText, (totalCount, gateways) => {
      this.setState({
        gateways: gateways,
        pageNumber: page,
        pages: Math.ceil(totalCount / this.state.pageSize),
      });
    });

    window.scrollTo(0, 0);
  }

  onSortClick = (key)=> {
    const currentSort  = this.state.currentSort;
    const currentKey = this.state.currentSortkey;


    let nextSort;

    if (key === currentKey) {
      if (currentSort === 'asc'){
        nextSort = 'desc';
      } else{
        nextSort = 'asc';
      }
    }else{
      nextSort = 'asc';
    }

    this.setState({
        currentSortkey: key,
        currentSort: nextSort,
    },()=>{
      this.updatePage(this.props);
    });
  };

  onSearchCallback(text,ignoreActive){
    this.setState({
      searchText: text,
      ignoreActive: ignoreActive,
    },()=>{
      this.updatePage(this.props);
    });
  }

  addSortTh(array, key,label, col){
    if(this.state.currentSortkey===key){
      if(this.state.currentSort==="asc"){
        array.push(<th className={"" + col}><button type="button" onClick={this.onSortClick.bind(this,key)} className={"btn btn-xs btn-link"}>{label}<span className="glyphicon glyphicon-triangle-top text-primary"></span></button></th>);
      }else{
        array.push(<th className={"" + col}><button type="button" onClick={this.onSortClick.bind(this,key)} className={"btn btn-xs btn-link"}>{label}<span className="glyphicon glyphicon-triangle-bottom text-primary"></span></button></th>);
      }
    }else{
      array.push(<th className={"" + col}><button type="button" onClick={this.onSortClick.bind(this,key)} className={"btn btn-xs btn-link"}>{label}</button></th>);
    }
  }

  render() {
    const GatewayRows = this.state.gateways.map((gw, i) => <GatewayRow key={gw.mac} gateway={gw} />);
    this.ths = [];

    this.addSortTh(this.ths,"name","Name","col-md-3")
    this.addSortTh(this.ths,"mac","MAC","col-md-2")
    this.addSortTh(this.ths,"desc","Description","col-md-3")
    this.addSortTh(this.ths,"uptime","Uptime","col-md-1")
    this.addSortTh(this.ths,"active","Gateway activity (30d)","col-md-3")


    return(
      <div>
        <ol className="breadcrumb">
          <li><Link to="/organizations">Organizations</Link></li>
          <li><OrganizationSelect organizationID={this.props.params.organizationID} /></li>
          <li className="active">Gateways</li>
        </ol>
        <div className="clearfix">
          <div className="pull-left">
            <SearchBox onSearch={this.onSearchCallback.bind(this)}></SearchBox>
          </div>
          <div className={"btn-group pull-right " + (this.state.isAdmin ? '' : 'hidden')} role="group" aria-label="...">
            <Link to={`/organizations/${this.props.params.organizationID}/gateways/create`}><button type="button" className="btn btn-default">Create gateway</button></Link>
          </div>
        </div>
        <hr />
        <div className="panel panel-default">
          <div className="panel-body">
            <table className="table table-hover">
              <thead>
                <tr>
                  {this.ths}
                </tr>
              </thead>
              <tbody>
                {GatewayRows}
              </tbody>
            </table>
          </div>
          <Pagination pages={this.state.pages} currentPage={this.state.pageNumber} pathname={`/organizations/${this.props.params.organizationID}/gateways`} />
        </div>
      </div>
    );
  }
}

export default ListGateways;





// WEBPACK FOOTER //
// ./src/views/gateways/ListGateways.js